export default function Problem() {
  const problems = [
    {
      icon: 'ri-question-line',
      text: '太陽光発電の知識がなく、施主様への提案が難しい',
      emoji: '😰'
    },
    {
      icon: 'ri-tools-line',
      text: '仕入れルートや施工体制が整っていない',
      emoji: '🔧'
    },
    {
      icon: 'ri-file-list-3-line',
      text: '見積もり作成や補助金申請が煩雑で手間がかかる',
      emoji: '📋'
    },
    {
      icon: 'ri-customer-service-2-line',
      text: '施工後のメンテナンスやクレーム対応が不安',
      emoji: '🤔'
    }
  ];

  return (
    <section id="problem" className="py-12 md:py-12 bg-gradient-to-b from-teal-50/50 to-emerald-50/30">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Overview Image - all screens */}
        <div className="mb-10 -mx-4 sm:-mx-6 lg:-mx-8">
          <img 
            src="https://static.readdy.ai/image/a44b33c2a19c260b8697c4ae9afddc14/e3c464b7dc245a038aab03bc07bb8816.png" 
            alt="太陽光の面倒丸投げしませんか？工務店様必見" 
            className="w-full h-auto object-cover"
          />
        </div>

        <div className="text-center mb-8 md:mb-16">
          <div className="inline-flex items-center gap-2 bg-white text-teal-600 px-4 py-1.5 md:px-5 md:py-2 rounded-full text-xs md:text-sm font-semibold mb-4 md:mb-6 shadow-md">
            <i className="ri-emotion-sad-line"></i>
            工務店様のお悩み
          </div>
          <h2 className="text-2xl md:text-4xl font-bold text-gray-800 mb-3 md:mb-4">
            こんな事でお困りではありませんか？
          </h2>
          <div className="w-16 md:w-20 h-1 md:h-1.5 bg-gradient-to-r from-teal-400 to-emerald-400 mx-auto mt-4 md:mt-6 rounded-full"></div>
        </div>

        <div className="grid md:grid-cols-2 gap-4 md:gap-6 max-w-5xl mx-auto">
          {problems.map((problem, index) => (
            <div 
              key={index}
              className="bg-white p-5 md:p-8 rounded-2xl md:rounded-3xl shadow-md hover:shadow-xl transition-all duration-300 border border-teal-100 hover:border-teal-200 hover:scale-[1.02] cursor-pointer group"
            >
              <div className="flex items-start gap-3 md:gap-5">
                <div className="flex-shrink-0 w-10 h-10 md:w-14 md:h-14 bg-gradient-to-br from-teal-100 to-emerald-100 rounded-xl md:rounded-2xl flex items-center justify-center text-xl md:text-3xl group-hover:scale-110 transition-transform">
                  {problem.emoji}
                </div>
                <div className="flex-1">
                  <div className="flex items-center gap-2 mb-2 md:mb-3">
                    <i className="ri-checkbox-circle-fill text-teal-400 text-base md:text-lg"></i>
                    <span className="text-xs md:text-sm font-medium text-teal-500">チェック</span>
                  </div>
                  <p className="text-gray-700 text-sm md:text-base leading-relaxed">
                    {problem.text}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-10 md:mt-16">
          <div className="inline-flex items-center gap-2 md:gap-3 bg-gradient-to-r from-teal-400 to-emerald-400 text-white px-6 py-3 md:px-10 md:py-5 rounded-full shadow-lg">
            <i className="ri-arrow-down-circle-line text-xl md:text-2xl animate-bounce"></i>
            <p className="text-base md:text-xl font-bold">
              これらの悩み、すべて解決します！
            </p>
            <i className="ri-arrow-down-circle-line text-xl md:text-2xl animate-bounce"></i>
          </div>
        </div>
      </div>
    </section>
  );
}